import { protectWorkspaceAccessBeforeLoad } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { CustomSubdomainCreatePage } from 'features/customSubdomains'
import { canEditConfigurationPermission, canViewConfigurationPermission } from 'hooks/usePermission'

import { subdomainSchema } from './-subdomainsSchema'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/subdomains/$certificateId')({
  component: CustomSubdomainCreatePage,
  pendingMs: 1000 * 60,
  validateSearch: subdomainSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Subdomains'),
      },
    ],
  }),
  beforeLoad: async ({ params, context }) => {
    await protectWorkspaceAccessBeforeLoad(
      params.certificateId ? canViewConfigurationPermission : canEditConfigurationPermission,
      undefined,
      { context, params }
    )
  },
  params: {
    parse: ({ certificateId }) => ({
      certificateId: certificateId === 'new' ? '' : certificateId,
    }),
    stringify: ({ certificateId }) => ({
      certificateId: certificateId || 'new',
    }),
  },
})
